import {
  Avatar,
  Button,
  Card,
  Grid,
  makeStyles,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import { PersonAdd, PersonAddDisabled } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import CoachService from "../coach_service";
import ModelCardSelectedCoach from "./modelCardUsers";
import DeleteRoundedIcon from "@material-ui/icons/DeleteRounded";

import icon12 from "../../../../Images/Icon12.svg";
import DataService from "../../../../Service";
import el from "date-fns/locale/el";

const SearchResult = (props: any) => {
  const { coachType, searchSelectedCoachesId, resultArr } = props;
  const classes = useStyles();
  const history = useHistory();
  console.log(props, "props");
  const [coaches, setCoaches] = useState("");
  const [searchId, setSearchId] = useState<any>("");
  const [coachesCount, setCoachesCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const [selectedCoachesList, setSelectedCoachesList] = useState<any>([]);
  const [selectedCoaches, setSelectedCoaches] = useState<any>([]);

  useEffect(() => {
    props.resultArr.length > 0 ? getSelectedCoaches() : getSearchId();
  }, [coaches]);

  const buttonClassFinder = (numb: any) => {
    switch (numb % 3) {
      case 0:
        return classes.btnBlue;
      case 1:
        return classes.btnGreen;
      case 2:
        return classes.btnOrange;
    }
  };
  const addSelectedCoach = (id: any, searchId: any, coachTypeCombined: any) => {
    setSelectedCoachesList(selectedCoachesList.concat(id));
    setSearchId(searchId);
    setIsLoading(true);

    const wordArray = coachType.split("");

    // eternal => External
    // internal => Internal
    const capitalizedWord = [
      ...wordArray[0].toUpperCase(),
      ...wordArray.splice(1),
    ].join("");
   
    const combinedSearchType = props.resultArr && props.resultArr.map((row : any)=>row.type)
    console.log('resultArr123 :>> ', coachTypeCombined);
    let params = {};
    if(capitalizedWord === "External" || coachTypeCombined === "partner"){
     params = {
      type:coachTypeCombined,
      partner_profile_id :id,
      search_id: searchId,
      search_type: capitalizedWord,
    };
  }
  else if(capitalizedWord === "Internal" || coachTypeCombined === "employee") {
    params = {
      employee_id: id,
      type:coachTypeCombined,
      // partner_profile_id :id,
      search_id: searchId,
      search_type: capitalizedWord,
    };
  } 
// const testArray = coachType === "exernal" ? "partner_profile_id" : "employee_id";
    CoachService.addSelectedCoaches(params)
      .then((response) => {
        console.log(response);
        setCoachesCount((prevState: any) => prevState + 1);
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  };
  console.log(selectedCoaches, selectedCoachesList, "list");
  // deleting selected coach
  const deleteCoachHandler = (id: any, searchId: any) => {
    // setIsLoading(true);
    var localArr = selectedCoachesList.filter((option: any) => option != id);
    // if(!selectedCoaches.length){
    //   getSelectedCoaches();
    // }
    const selectedId: any = selectedCoaches.filter((el: any) => {
      return el.partner_profile_id === id;
    });
    removeCoach(selectedId[0]?.id, selectedId[0]?.partner_profile_id);
    // setSelectedCoachesList(localArr)
  };

  const removeCoach = (search_list_id: any, id: any) => {
    CoachService.removeSelectedCoaches({
      search_list_id: search_list_id,
    })
      .then((response) => {
        console.log(`selectedCoachesList`, selectedCoachesList);
        // setCoachesCount((prevState) => prevState - 1);
        getSelectedCoaches();
        setCoaches("");
        var localArr = selectedCoachesList.filter(
          (option: any) => option != id
        );
        setSelectedCoachesList(localArr);
      })
      .finally(() => setIsLoading(false));
  };

  // fetching selected coaches
  const getSelectedCoaches = () => {
    CoachService.getSelectedCoaches({
      search_id: searchId || searchSelectedCoachesId || undefined,
    }).then((response) => {
      setSelectedCoaches(response.data || []);
      setSelectedCoachesList(
        response.data?.map((el: any) => el.partner_profile_id) || []
      );
      setCoachesCount(response.data?.length || 0);
    });
  };
  // fetching selected coaches
  const getSearchId = () => {
    DataService.getDirectData(
      "searches/find_search?search_type=" + coachType,
      {}
    ).then((response: any) => {
      setSearchId(response.search_id);
      CoachService.getSelectedCoaches({
        search_id: response.search_id,
      }).then((response) => {
        if (response.data) {
          setSelectedCoaches(response.data || []);
          setSelectedCoachesList(response.data || []);
          setCoachesCount(response.data.length || 0);
        }
      });
    });
  };

  console.log(searchId, "search id");
  return (
    <>
      <Grid
        container
        direction="row"
        justify="center"
        style={{ border: "0px solid red", marginTop: 20 }}
      >
        <Grid item xs={12} alignItems="flex-start">
          <label className={classes.headingTitle}>Search results</label>
        </Grid>
        <Grid
          item
          xs={2}
          alignItems="flex-end"
          style={{
            border: "0px solid red",
            position: "fixed",
            bottom: 30,
            right: "16%",
            zIndex: 9,
          }}
        >
          {/* <div style={{ position: "relative" }}>
            <Avatar
              className={classes.large}
              onClick={() =>
                coaches === "active" ? setCoaches("") : setCoaches("active")
              }
              style={{
                marginTop: 2,
                float: "right",
                backgroundColor: "#077F83",
              }}
              alt=""
              src="/static/images/avatar/1.jpg"
            />
            <div className={classes.couchCounts}>{coachesCount}</div>
          </div> */}
          {coaches === "active" && (
            <Backdrop open={true} invisible onClick={() => setCoaches("")}>
              <ModelCardSelectedCoach
                searchId={searchId}
                data={selectedCoaches}
                coachFlag={setCoaches}
                count={coachesCount}
                deleteCoachHandler={removeCoach}
                isLoading={isLoading}
                getSelectedCoaches={getSelectedCoaches}
              />{" "}
            </Backdrop>
          )}
        </Grid>
      </Grid>

      {props.resultArr.length > 0 &&
        props.resultArr[0] !== undefined &&
        props.resultArr.map((e: any, i: any) => {
          return (
            <Grid
              container
              direction="row"
              justify="center"
              style={{ border: "0px solid red" }}
              key={e.id}
            >
              <Grid item xs={12} style={{}}>
                <Card
                  variant="outlined"
                  style={{ padding: "20px", marginTop: 30, borderRadius: 0 }}
                >
                  <Grid
                    container
                    direction="row"
                    justify="center"
                    className={classes.deviderLine}
                  >
                    <Grid item xs={1} style={{ border: "0px solid blue" }}>
                      <div>
                        <Avatar
                          style={{}}
                          alt=""
                          src="/static/images/avatar/1.jpg"
                        />
                      </div>
                    </Grid>
                    <Grid item xs={9} style={{ border: "0px solid yellow" }}>
                      <Grid container direction="row" justify="center">
                        <Grid item xs={12}>
                          <label className={classes.userTitle}>
                            {e.first_name + " " + e.last_name}
                          </label>
                        </Grid>
                        <Grid item xs={4}>
                          <label
                            className={classes.userId}
                            style={{ textTransform: "uppercase" }}
                          >
                            Id : {e.id}
                          </label>
                        </Grid>
                        <Grid item xs={8}>
                          {e.type && (
                            <label
                              className={classes.userId}
                              style={{ fontWeight: "bolder" }}
                            >
                              {e.type === "partner" ? "External" : "Internal"}
                            </label>
                          )}
                          <br />
                          <label className={classes.userId}>
                            E-Mail:
                            <label style={{ textTransform: "lowercase" }}>
                              {e.email ? e.email : e.primary_email}
                            </label>
                          </label>
                          <div>
                            <div className={classes.onlineCircle}></div>
                            <label className={classes.onlineAvailable}>
                              {e.currently_available_for_assignment}
                            </label>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={2} style={{ border: "0px solid red" }}>
                      <Button
                        disableElevation
                        variant="contained"
                        color="primary"
                        className={classes.btnSearch}
                        onClick={() => {
                          let params = {
                            id: e.id,
                            coachType: coachType,
                            selectedType: undefined,
                          };
                          if (coachType === "combined") {
                            params.selectedType = e.type;
                          }
                          history.push("CoachDetail", params);
                        }}
                      >
                        View Profile
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    direction="row"
                    justify="center"
                    style={{ marginTop: 10 }}
                  >
                    <Grid item xs={1} style={{}}></Grid>
                    <Grid item xs={8} style={{ marginTop: 10 }}>
                      {e.work_sector.length > 0 &&
                        (e.selected_attribute.includes("true") ||
                          e.selected_attribute.includes("false")) &&
                        e.work_sector.map((el: any, ind: number) => {
                          return (
                            <Button
                              disableElevation
                              variant="contained"
                              color="primary"
                              className={buttonClassFinder(ind)}
                            >
                              {el}
                            </Button>
                          );
                        })}

                      {e.selected_attribute
                        .filter(
                          (test: any) =>
                            !(test.includes("true") || test.includes("false"))
                        )
                        .map((el: any, ind: number) => {
                          return (
                            <Button
                              disableElevation
                              variant="contained"
                              color="primary"
                              className={buttonClassFinder(ind)}
                            >
                              {el}
                            </Button>
                          );
                        })}
                    </Grid>
                    {/* <Grid item xs={3} style={{}}>
                      <Button
                        disableElevation
                        variant="outlined"
                        size="small"
                        className={classes.addCoachBtn}
                        startIcon={
                          selectedCoachesList.length > 0 ? (
                            selectedCoachesList.indexOf(e.id) === -1 ? (
                              <PersonAdd
                                style={{ opacity: isLoading ? 0 : 1 }}
                              />
                            ) : (
                              <DeleteRoundedIcon
                                style={{ opacity: isLoading ? 0 : 1 }}
                              />
                            )
                          ) : (
                            <PersonAdd />
                          )
                        }
                        onClick={() => {
                          selectedCoachesList.length > 0
                            ? selectedCoachesList.indexOf(e.id) === -1
                              ? addSelectedCoach(e.id, e.search_id,e.type)
                              : deleteCoachHandler(e.id, e.search_id)
                            : addSelectedCoach(e.id, e.search_id,e.type);
                        }}
                      >
                        {selectedCoachesList.length > 0
                          ? selectedCoachesList.indexOf(e.id) === -1
                            ? "Add coach to your list"
                            : "Remove From List"
                          : "Add coach to your list"}
                      </Button>
                    </Grid> */}
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          );
        })}
      {props.resultArr.length === 0 && (
        <Grid container direction="row" alignItems="center">
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              textAlign: "center",
            }}
          >
            <img src={icon12} alt="not found" style={{ height: 40 }} />
            <label className={classes.noUserTitle}>No results found</label>
          </Grid>
        </Grid>
      )}
    </>
  );
};
export default SearchResult;

const useStyles = makeStyles((theme) => ({
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  headingTitle: {
    fontSize: 18,
    fontWeight: "bold",
    // marginLeft: 20,
  },
  userTitle: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#4D4F5C",
  },
  userId: {
    fontSize: 14,
    color: "#707070",
    lineHeight: 2,
  },
  couchCounts: {
    width: 15,
    height: 15,
    borderRadius: "50px",
    backgroundColor: "#077F83",
    color: "#fff",
    position: "absolute",
    right: -4,
    fontSize: 10,
    textAlign: "center",
    border: "1px solid ",
    borderColor: "#fff",

    cursor: "pointer",
  },
  onlineCircle: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    backgroundColor: "#21BA45",
    display: "inline-block",
  },
  onlineAvailable: {
    marginLeft: 10,
    color: "#21BA45",
    fontSize: 14,
  },
  btnSearch: {
    backgroundColor: "#981b1e",
    borderRadius: "0",
    textTransform: "capitalize",
    // width: 100,
    fontSize: "12px",
    boxShadow: "none",
    float: "right",
    "&:hover": {
      backgroundColor: "none",
    },
  },
  deviderLine: {
    borderBottom: "1px solid #F1F1F3",
    paddingBottom: 10,
  },
  btnBlue: {
    textTransform: "capitalize",
    backgroundColor: "#40C9FC",
    fontSize: 11,
    marginRight: 20,
    boxShadow: "none",
  },
  btnOrange: {
    textTransform: "capitalize",
    backgroundColor: "#FFCC53",
    fontSize: 11,
    marginRight: 20,
    boxShadow: "none",
  },
  btnGreen: {
    textTransform: "capitalize",
    backgroundColor: "#4AD991",
    fontSize: 11,
    marginRight: 20,
    boxShadow: "none",
  },
  addCoachBtn: {
    border: "1px solid #981B1E",
    color: "#981B1E",
    textAlign: "center",
    fontSize: 12,
    borderRadius: 4,
    float: "right",
    padding: "5px 10px",
    width: "180px",
    textTransform: "capitalize",
  },
  menuOption: {
    border: "0px solid red",
    position: "absolute",
    zIndex: 1,
    // maxWidth: 360,
    // minWidth: 330,
    bottom: 0,
    right: 43,
  },
  noUserIcon: {
    fontSize: 35,
    color: "#40C9FC",
    width: "100%",
  },
  noUserTitle: {
    fontSize: 14,
  },
}));
